import React from 'react';
import { CheckCircle2, Phone } from 'lucide-react';
const PHONE = '586-203-3701';
export function ShingleFocus() {
  return <section className="bg-white py-20 sm:py-24" data-id="element-291">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-292">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-293">
          {/* Image */}
          <div className="relative" data-id="element-294">
            <img src="https://cdn.magicpatterns.com/uploads/i1Y2DSyZWn6zHA8rZ9u5rN/roof-replacement.jpg" alt="Completed Moceri shingle roof replacement on a Michigan home — drone view showing new architectural shingles with Moceri Roofing service van" className="w-full h-[420px] sm:h-[520px] object-cover rounded-2xl shadow-xl" data-id="element-295" />
            <div className="absolute -bottom-6 -right-6 hidden md:flex flex-col bg-[#2DB8E0] text-white px-6 py-4 rounded-xl shadow-lg" data-id="element-296">
              <span className="font-display italic text-3xl leading-none" data-id="element-297">
                25+
              </span>
              <span className="text-sm font-semibold uppercase tracking-wide mt-1" data-id="element-298">
                Years roofing
                <br data-id="element-299" />
                Michigan homes
              </span>
            </div>
          </div>

          {/* Copy */}
          <div data-id="element-300">
            <span className="inline-block text-[#2DB8E0] font-bold uppercase tracking-wider text-sm mb-4" data-id="element-301">
              Shingle Roof Replacement
            </span>
            <h2 className="font-display italic text-4xl sm:text-5xl text-[#1a2332] leading-tight mb-6" data-id="element-302">
              Built for Michigan. Backed by Quality.
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-6" data-id="element-303">
              Michigan winters are brutal on shingle roofs. Ice dams,
              freeze-thaw cycles, and heavy snow loads can take years off a
              poorly-installed roof. We use premium architectural shingles rated
              for Michigan's extreme weather — installed by a crew that's been
              doing this for decades.
            </p>

            <ul className="space-y-3 mb-8" data-id="element-304">
              {['Complete tear-off of old roofing materials', 'Decking inspection & repair where needed', 'Premium ice & water shield protection', 'Architectural shingles — 25 to 50 year lifetime warranties', 'Proper ventilation & ridge cap installation', 'Full cleanup with magnetic nail sweep'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-305">
                  <CheckCircle2 className="w-6 h-6 text-[#2DB8E0] flex-shrink-0 mt-0.5" data-id="element-306" />
                  <span className="text-slate-700 font-medium" data-id="element-307">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-308">
              <a href="#quote-form" className="inline-flex items-center justify-center bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold px-7 py-4 rounded-full transition-all shadow-md hover:shadow-lg" data-id="element-309">
                <span className="mr-2" data-id="element-310">—</span>
                Get a Quote Now!
                <span className="ml-2" data-id="element-311">—</span>
              </a>
              <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center justify-center gap-2 border-2 border-[#1a2332] text-[#1a2332] hover:bg-[#1a2332] hover:text-white font-bold px-6 py-4 rounded-full transition-colors" data-id="element-312">
                <Phone className="w-5 h-5" data-id="element-313" /> {PHONE}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}